@if (text) {
  <article class="text-container">
    <div class="text" [innerHTML]="text | safe:'html'"></div>
  </article>
}
